import { RouteFactory } from "@app/routePaths";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import { VERTICAL_MASTHEADS } from "@routes/Section/layouts/Verticals/utils/constant";
import { cn } from "@util/helpers";

type SMEBannerProps = {
  /** Optional additional styling to the component */
  className?: string;
};

/**
 * Banner component for the SME vertical, featuring the masthead and sponsor logo.
 */
const SMEBanner = ({ className }: SMEBannerProps): React.ReactElement => {
  return (
    <div
      className={cn(
        "mx-auto flex w-full flex-wrap items-center justify-center gap-4 border-b border-gray-175 pb-4 lg:justify-between",
        className
      )}
    >
      <SectionMasthead
        link={RouteFactory.sgsme}
        masthead={VERTICAL_MASTHEADS.sme}
        className="w-[8.125rem] lg:w-[9.375rem]"
      />
    </div>
  );
};

export default SMEBanner;
